<template>
  <div class="page">
    <p class="p1">
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="long-Class">
      <div class="log-class">
        <p class="img-log">用户登陆</p>
      </div>
      <nut-textinput v-model="propsParams.phone" placeholder="请输入手机号" type="tel" maxlength="11" @blur="phoneValidate"/>
      <div class="position: relative;">
        <nut-textinput v-model="propsParams.verCode"  placeholder="请输入验证码"  type="tel" maxlength="4" :clearBtn="false"/>
        <div class="input-code">
          <span v-show="show" @click="getCode" class="opt-a">获取验证码</span>
          <span v-show="!show" class="count opt-a">{{count}}s后可重发</span>
        </div>
      </div>
      <div class="search-box" v-show="showType">
        <input type="text" v-model="propsParams.userType" class="search-input" placeholder="请选择类型" @click="openSwitch('isVisible')" onfocus="this.blur()">
      </div>
      <button class="button-class" @click="loginButton()">立即登陆</button>
      <!-- 选择类型的弹窗-->
      <nut-picker 
        :is-visible="isVisible" 
        :list-data="listData" 
        :default-value-data="defaultValueData" 
        @close="closeSwitch('isVisible')" 
        @confirm="confirm"
      ></nut-picker>
    </div>

  </div>
</template>
<script>
import { wx_sendWxUserSms } from "@/api/api.js"; //发送验证码
import { wx_userLogin } from "@/api/api.js"; //发送验证码
import { wx_userPhone } from "@/api/api.js"; //发是否注册
export default {
  data() {
    return {
      propsParams:{
        phone:"",
        verCode:"",
        userType:""
      },
      code:undefined,
      channel:undefined,
      showType:false,
      show: true,
      count: "",
      timer: null,
      option: '请选择',
      isVisible: false,
      listData: [[
         { label: 1,value: '监控', },
         { label: 2,value: '充电桩', },
         { label: 3,value: '执法仪', },
         { label: 4,value: '售货机', },
         { label: 5,value: '门禁', },
         { label: 6,value: '其他', },
      ]],
      defaultValueData: []
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    phoneValidate(){
        const phone = this.propsParams.phone;
        if(!!phone && phone.length==11){
            //验证是否注册
            wx_userPhone({phone:phone}).then(res=>{
              if(res.data.code == 310){
                  this.showType = true;
              }
            })
        }
    },
    getCode(){
      let params={
        phone: this.propsParams.phone
      };
      wx_sendWxUserSms(params).then(res=>{
        if(res.data.code == 200){
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      })
    },
    loginButton(){
      let params ={
        ...this.propsParams
      };
      params.code = this.code;
      params.channel = this.channel;
      wx_userLogin(params).then(res=>{
        if(res.data.code == 200){
          localStorage.setItem("mobileToken", res.data.data.token);
          this.$router.push({
            name: "userCenterPersona",
          });
        }else if(res.data.code == 310){
            this.showType = true;
        }else{
          this.$toast.fail(res.data.message);
        }
      })
    },
    // 判断token是否存在
    initData() {
      if (localStorage.getItem("mobileToken")) {
        setTimeout(() =>{
          this.$router.push({
            name: "userCenterPersona",
          });
        },50)
      }
    },
    // 账户积分兑换
    openSwitch(param){
      this[`${param}`] = true;
    },
    // 取消选择
    closeSwitch(param){
      this[`${param}`] = false;
    },
    // 确认选择
    confirm(chooseData) {
      this.propsParams.userType = `${chooseData[0].value}`
    },
    getUrlParam(name) {
      const href = window.location.href;
      let reg = new RegExp( '[?&]' + name + '=([^&]*)', 'i' );
      let string = reg.exec(href);
      return string ? string[1] : null;
    },
  },
  created() {
    //验证是否已经登录
    this.code = this.getUrlParam("code") || localStorage.getItem("code");
    this.channel = this.getUrlParam('channel') || localStorage.getItem("channel");
    localStorage.setItem("code",this.code);
    localStorage.setItem("channel",this.channel);
    this.initData();
  },
  mounted() {
    window.document.title = "登陆";
  },
};
</script>
<style scoped lang="less">
  .page{
    background:url(../../assets/img/31.png);
    background-size: 100% 100%;
    height: 100%;
    width: 100%;
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      // background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .long-Class{
      width: 90%;
      height: 65%;
      margin: 0 auto;
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%,-50%);
    }
    .log-class{
      width: 100%;
      text-align: center;
    }
    .img-log{
      height: 180px;
      line-height: 180px;
      font-size: 26px;
    }
    .nut-textinput{
      width: 85% !important;
      margin-bottom: 40px !important;
      margin: 0 auto;
    }
    /deep/ .nut-textinput input{
      border: 1px solid #999;
    }
    .button-class{
      width: 85%;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      text-align: center;
      display: block;
      border:none;
      background: #f94040;
      color:#fff;
      font-size:16px;
      margin-top: 40px;
    }
    .input-code {
      position: absolute;
      right: 55px;
      top: 305px;
      height: 30px;
      .opt-a {
        display: block;
        width: 75px;
        height: 30px;
        line-height: 30px;
        background: #F94040;
        color: #fff;
        font-size: 12px;
        text-align: center;
      }
    }
    .search-box {
      margin: 0px auto 15px;
      text-align: center;
      border: none;
    }
    .search-input {
      width: 85%;
      height: 40px;
      line-height: 40px;
      border: 1.2px solid #999;
      border-radius: 5px;
      text-indent: 15px;
      outline: none;
      font-size: 14px;
    }
    input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{
      color:#C1C4CB;
    }
  }
</style>

